import './lib/sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { CT } from './lib/theme';
import './index.css';

function FallbackUI({ error }: { error: Error }) {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        background: CT.darkGrey,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: CT.font,
        gap: 16,
      }}
    >
      <div style={{ color: '#f87171', fontSize: 16, fontWeight: 600 }}>
        Something went wrong
      </div>
      <div style={{ color: CT.paleGrey, fontSize: 13, maxWidth: 480, textAlign: 'center' }}>
        {error.message}
      </div>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: 8,
          padding: '8px 20px',
          border: 'none',
          borderRadius: 6,
          background: CT.primaryBlue,
          color: CT.white,
          fontSize: 13,
          fontFamily: CT.font,
          cursor: 'pointer',
        }}
      >
        Reload
      </button>
    </div>
  );
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ error }) => <FallbackUI error={error instanceof Error ? error : new Error(String(error))} />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
